export class GenericElement {
    name: string;
    type: string | null;
    id: string | null;

    constructor(name: string, type: string | null, id: string | null) {
        this.name = name;
        this.type = type;
        this.id = id;
    }
}